<template>
    <div>
        <el-row :gutter="24" :data="infoData">
            <el-col :span="7">
                <div class="grid-content bg-purple">
                    <div class="label">
                        分公司：
                        <span class="value" :title="infoData.companyName">{{infoData.companyName}}</span>
                    </div>
                    <div class="label">
                        服务平台：
                        <span class="value" :title="infoData.siteName">{{infoData.siteName}}</span>
                    </div>
                    <div class="label">
                        会计主体：
                        <span class="value" :title="infoData.ledgerName">{{infoData.ledgerName}}</span>
                    </div>
                    <div class="label">
                        是否发生事故：
                        <span class="value" :title="infoData.isAccident">{{infoData.isAccident}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="5">
                <div class="grid-content bg-purple">
                    <div class="label">
                        业务类型：
                        <span class="value" :title="infoData.operationType">
                            {{infoData.operationType}}
                        </span>
                    </div>
                    <div class="label">
                        发车单号：
                        <span class="value" :title="infoData.accidentNo">{{infoData.accidentNo}}</span>
                    </div>
                    <div class="label">
                        计费供应商：
                        <span class="value" :title="infoData.feeSupplierName">{{infoData.feeSupplierName}}</span>
                    </div>
                    <div class="label">
                        事故单号：
                        <span class="value" :title="infoData.accidentNo">{{infoData.accidentNo}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">
                        罚款或扣款：
                        <span class="value" :title="infoData.profitTypeName">{{infoData.profitTypeName}}</span>
                    </div>
                    <div class="label">
                        罚扣款总额(本币)：
                        <span class="value" :title="infoData.initialTotalAmt">{{infoData.initialTotalAmt}}</span>
                    </div>
                    <div class="label">
                        核销时间：
                        <span class="value" :title="infoData.chargeoffTime">{{infoData.chargeoffTime}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">
                        币种：
                        <span class="value" :title="infoData.currencyCode">{{infoData.currencyCode}}</span>
                    </div>
                    <div class="label">
                        是否代开发票：
                        <span class="value" :title="infoData.isReplaceSettlement">{{infoData.isReplaceSettlement}}</span>
                    </div>
                    <div class="label">
                        备注：<span class="value" :title="infoData.remark">{{infoData.remark}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="big-money">
                    <div class="money-head">
                        <span class="money">{{infoData.totalAmt ? infoData.totalAmt : 0}}</span>  <span>元</span>
                    </div>
                    <div class="text">罚扣款总额</div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: {
        infoData: {
            type: Object
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="less">
</style>